import React, { Component } from 'react';
import { connect } from "react-redux";
import GTMTBarChart from '../../components/bar-charts/GTMTBarChart';
import CustomSelect from "../../components/common/select/Select";
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import DATA from '../../assets/data';
import { compare } from '../gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

class GTMTSplit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: [],
            selectedYear: [],
            selectedPromoType: [],
            selectedMonth: [],
            data: [],
            popUp: false,
            months: DATA.QUARTER_MONTHS,
            years: DATA.YEARSPreVsPostOpso,
            masterChannel: DATA.GEOCHANNEL,
            filePopUp:false
        };
    }

    componentDidMount() {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        let currentYearIndex = this.state.years.findIndex(year => year.value === currentYear);

        this.handleYearCheckonMounting(currentYearIndex - 1)       // Marking year one less than current year check on component mounting
        this.handleYearCheckonMounting(currentYearIndex)       // Marking current year check on component mounting

        let arr = []
        if (this.props.categories) {
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                setTimeout(() => {
                    this.handleSubmit()
                }, 700)
            })
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.GTMTSplit) {
                this.propsReceived(nextProps.GTMTSplit);
        }
    }

    propsReceived = (value) => {
        let arr = value;
        var popUip = [];
        if(arr){
            arr.forEach((item,ind)=>{
                if(item.Division === 'UIP'){
                    popUip = arr.splice(ind, 1)
                }
            })
        }

        if(popUip.length){
            arr.unshift(popUip[0])
        }

        this.setState({
            data:arr
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.categories !== this.props.categories) {
            let arr = []
            this.props.categories.forEach(item => {
                arr.push(item.guid)
            })
            this.setState({
                selectedCategory: arr
            }, () => {
                this.handleSubmit();
            })
        }
    }

    handleCategory = (category) => {
        let arr = [];
        if (category === null || category.length === 0) {
            this.setState({
                selectedCategory: []
            }, () => {
                this.handleSubmit()
            });
        } else {
            category.forEach((element) => {
                arr.push(element.value);
            });
            this.setState({ selectedCategory: arr }, () => {
                this.handleSubmit()
            });
        }
    };

    handleSubmit = () => {
        this.props.getGTMTSplit(
            this.state.selectedCategory,
            this.state.selectedYear,
            this.state.selectedMonth,
            this.state.selectedMasterChannel
        );
    }

    handleMonthCheck = (ind) => {
        let newArray = [...this.state.months]
        newArray[ind] = { ...newArray[ind], gtmtChecked: !newArray[ind].gtmtChecked }
        // this.state.months[ind].gtmtChecked = !this.state.months[ind].gtmtChecked
        this.setState({
            months: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.months.forEach(item => {
                    if (item.gtmtChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedMonth: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })

    }

    handleYearCheck = (ind) => {
        if (this.state.selectedYear.length === 5 && !this.state.years[ind].gtmtChecked) {
            CustomToast('warning', 'Can not select more than five years')
            return;
        }
        let newArray = [...this.state.years]
        newArray[ind] = { ...newArray[ind], gtmtChecked: !newArray[ind].gtmtChecked }
        // this.state.years[ind].gtmtChecked = !this.state.years[ind].gtmtChecked
        this.setState({
            years: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.gtmtChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    handleYearCheckonMounting = (ind) => {
        // let newArray = [...this.state.years]
        // newArray[ind] = {...newArray[ind], gtmtChecked: true}
        this.state.years[ind].gtmtChecked = true            // eslint-disable-line
        this.setState({
            years: this.state.years
        },
            () => {
                let filterCheckedValues = []
                this.state.years.forEach(item => {
                    if (item.gtmtChecked) {
                        filterCheckedValues.push(item.value)
                    }
                })
                this.setState({
                    selectedYear: filterCheckedValues
                })
            })
    }

    handleChannelCheck = (ind) => {
        let newArray = [...this.state.masterChannel]
        newArray[ind] = { ...newArray[ind], checked: !newArray[ind].checked }
        // this.state.masterChannel[ind].checked = !this.state.masterChannel[ind].checked
        this.setState({
            masterChannel: newArray
        },
            () => {
                let filterCheckedValues = []
                this.state.masterChannel.forEach(item => {
                    if (item.checked) {
                        filterCheckedValues.push(item.guid)
                    }
                })
                this.setState({
                    selectedMasterChannel: filterCheckedValues
                }, () => {
                    this.handleSubmit()
                })
            })
    }

    handleGtMtSplitXlsxDownload = () => {
        if (this.state.selectedCategory.length) {
            this.props.downloadGtMtSplitXlsx(this.state.selectedCategory)
        } else {
            CustomToast('error', 'Category not selected!')
        }
    }

    render() {
        return (
            <div className='dtts-container' style={{ marginRight: '8px', minHeight: '600px' }}>

                <div className='dtts-heading-cta'>

                    <span className='dtts-heading'>GT/MT Split</span>

                    <CustomSelect.MyCustomSelect
                        className='filter-font-size'
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.categories
                                ? !this.props.categories
                                    ? void 0
                                    : this.props.categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.categories
                                ? this.props.categories
                                    .filter(item => {
                                        return !this.state.selectedCategory
                                            ? void 0
                                            : this.state.selectedCategory.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />
                    <div className='dtts-cta-container'>
                        <div className='funnel-filter-container'>
                            <img alt='' className='funnel-filter-image' src={require('../../assets/images/funnelFilter.svg')} onClick={() => { this.setState({ popUp: !this.state.popUp }) }} />
                            {/* Funnel Icon Popup Filter */}
                            {this.state.popUp ?
                                <ClickAwayListener onClickAway={() => { this.setState({ popUp: false }) }}>
                                    <div className='funnel-pop-up' style={{ width: '435px' }}>

                                        <div className='popUp-columns' style={{ textAlign: 'left' }}>
                                            <span className='popUp-heading'>Channel</span>

                                            <div className='promo-column'>
                                                {this.state.masterChannel.map((item, indx) => (
                                                    <span className='column-item' key={item.name + `${indx}`}>
                                                        <input type='checkbox' className='column-item-input' checked={item.checked}
                                                            onChange={() => this.handleChannelCheck(indx)} />
                                                        <label>{item.name}</label>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Month</span>
                                            <div className='month-column'>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind <= 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.gtmtChecked}
                                                                        onChange={() => this.handleMonthCheck(indx)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                                <div className='promo-column'>
                                                    {
                                                        this.state.months.filter((item, ind) => {
                                                            return ind > 5 ? item : null
                                                        })
                                                            .map((item, indx) => (
                                                                <span className='column-item' key={indx}>
                                                                    <input type='checkbox' className='column-item-input' checked={item.gtmtChecked}
                                                                        onChange={() => this.handleMonthCheck(indx + 6)} />
                                                                    <label>{item.name}</label>
                                                                </span>
                                                            ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className='popUp-columns'>
                                            <span className='popUp-heading'>Year</span>
                                            <div className='promo-column'>
                                                {
                                                    this.state.years.map((item, indx) => (
                                                        <span className='column-item' key={indx}>
                                                            <input type='checkbox' className='column-item-input' checked={item.gtmtChecked}
                                                                onChange={() => this.handleYearCheck(indx)} />
                                                            <label>{item.label}</label>
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </ClickAwayListener>
                                :
                                null
                            }
                        </div>
                        <img alt='' className='images-style' src={require('../../assets/images/refreshArrows.svg')} onClick={this.handleSubmit} />
                        <div className="funnel-filter-container">
                            <div style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={() => {
                                    this.setState({ filePopUp: !this.state.filePopUp });
                                }}
                            >
                                <img
                                    className="image-transform"
                                    src={require("../gt/images/dots.png")}
                                    alt=''
                                />
                            </div>

                            {this.state.filePopUp ? (
                                <ClickAwayListener
                                    onClickAway={() => {
                                        this.setState({ filePopUp: false });
                                    }}
                                >
                                    <div
                                        className="funnel-pop-up"
                                        style={{ width: "140px", height: 'auto', flexDirection: 'column' }}
                                    >
                                        {/* <span className="division-cta">
                                            <input type='checkbox' value={this.state.isDivision} onChange={() => this.setState({ isDivision: !this.state.isDivision })} />
                                            <label>Division</label>
                                            </span> */}
                                        <button className='xlsx-download-cta' onClick={this.handleGtMtSplitXlsxDownload}>Download Excel</button>
                                    </div>
                                </ClickAwayListener>
                            ) : null}
                        </div>
                    </div>

                </div>

                {this.props.isGTMTSplitLoading ?
                    <div style={{ marginTop: '100px' }}>
                        {/* Loading */}
                        <img alt='' src={require('../../assets/images/barsLoader.svg')} style={{ width: '60px', height: '60px' }} />
                    </div>
                    :
                    // Graph
                    <GTMTBarChart data={this.state.data} />
                }

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        GTMTSplit: state.PratDashboardReducer.GTMTSplit,
        isGTMTSplitLoading: state.PratDashboardReducer.isGTMTSplitLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getGTMTSplit: (
            selectedCategory,
            selectedYear,
            selectedMonth,
            selectedMasterChannel
        ) => {
            return dispatch(PratDashboardMiddleware.getGTMTSplit(
                selectedCategory,
                selectedYear,
                selectedMonth,
                selectedMasterChannel
            ));
        },
        downloadGtMtSplitXlsx: (selectedCategory) => {
          return dispatch(
            PratDashboardMiddleware.downloadGtMtSplitXlsx(
              selectedCategory,
            )
          );
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GTMTSplit);
